/* eslint-disable */
import {
    CardCvcElement,
    CardElement, CardExpiryElement, CardNumberElement,
    PaymentRequestButtonElement,
    useElements,
    useStripe
} from "@stripe/react-stripe-js";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useFunnelStore} from "../../../store/useFunnelStore";
import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import {pushInfoToGoogleData} from "../../../utils/googleTag";
import {facebookEventFire} from "../../../utils/facebookEventFire";
import {quizService} from "../../../api/quizService";
import PayPalElement from "../paypal/PayPalElement";

export const getLocalCheckoutData = () => {
    const savedData = localStorage.getItem('checkout_info');
    return savedData ? JSON.parse(savedData) : null;
};

const CheckoutForm = ({ priceId, secondPrice, price, coupon, isSingle, clientSecret }:
                          { priceId: string, price: any, secondPrice: any, isSingle: boolean, clientSecret: string, coupon?: any, paymentIntentId:string }) => {
    const stripe = useStripe();
    const navigate = useNavigate();
    const location = useLocation();
    const {getFunnel, getStatus, saveCheckoutData, updateCheckoutField, getAllFunnelData, getCheckoutData } = useFunnelStore();
    const elements = useElements();
    const { t } = useTranslation();
    const [name, setName] = useState('');
    const [email, setEmail] = useState(localStorage.getItem('userEmail') || '');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [selectedMethod, setSelectedMethod] = useState<'card' | 'gpay' | 'applepay'>('card');
    const [paymentRequest, setPaymentRequest] = useState<any>(null);
    const { funnelId } = useParams<{ funnelId: string }>();
    const [cardNComplete, setCardNComplete] = useState(false);
    const [cardExComplete, setCardExComplete] = useState(false);
    const [cardCvComplete, setCardCvComplete] = useState(false);
    const [couponId, saveCouponId] = useState('');
    const [productId, saveProductId] = useState('');
    // UI state: selected card brand image and shake effect for CardElement
    const [selectedBrand, setSelectedBrand] = useState<'visa' | 'mastercard' | 'amex' | null>(null);
    const [shake, setShake] = useState(false);

    const onBrandClick = (brand: 'visa' | 'mastercard' | 'amex') => {
        // setSelectedBrand(brand);
        // Focus the Stripe CardElement and trigger a shake animation
        try {
            const card = elements?.getElement(CardNumberElement);
            // @ts-ignore focus exists on StripeElement
            card?.focus && card.focus();
        } catch (e) {
            // no-op
        }
        setShake(true);
        setTimeout(() => setShake(false), 500);
    };

    const handleCardChange = (event: any) => {
        setCardNComplete(event.complete);
    };
    const handleCvChange = (event: any) => {
        setCardCvComplete(event.complete);
    }

    const handleExpChange = (event: any) => {
        setCardExComplete(event.complete);
    }

    useEffect(() => {
        pushInfoToGoogleData({
            event: 'payment_page_view',
            data: {
                cardTitle: 'Checkout',
            }
        })
        facebookEventFire('PaymentPageView', {
            userData: {},
            customData: {cardTitle: 'Checkout'},
        })
    }, [])
    // Load saved checkout data on component mount
    useEffect(() => {
        const savedCheckoutData = getCheckoutData();
        if (savedCheckoutData.email) {
            setEmail(savedCheckoutData.email);
        }
        if (savedCheckoutData.name) {
            setName(savedCheckoutData.name);
        }
    }, [getCheckoutData]);

    // Save checkout data to store when form fields change
    useEffect(() => {
        if (email) {
            updateCheckoutField('email', email);
        }
    }, [email, updateCheckoutField]);

    useEffect(() => {
        if (name) {
            updateCheckoutField('name', name);
        }
    }, [name, updateCheckoutField]);

    useEffect(() => {
        if (priceId) {
            updateCheckoutField('selectedPrice', priceId);
        }
    }, [priceId, updateCheckoutField]);

    // Initialize Payment Request for Google Pay and Apple Pay
    useEffect(() => {
        if (stripe && price) {
            const savedData = getLocalCheckoutData();
            const productId = location.state?.productId || savedData?.productId;
            const couponId = location.state?.couponId || savedData?.couponId;

            saveProductId(productId)
            saveCouponId(couponId)

            // Calculate the final price with coupon discount
            const originalPrice = price.unit_amount;
            let finalAmount = originalPrice;

            if (coupon) {
                let discountAmount = 0;
                if (coupon.percent_off) {
                    discountAmount = (originalPrice * coupon.percent_off) / 100;
                } else if (coupon.amount_off) {
                    discountAmount = coupon.amount_off; // Already in cents
                }
                finalAmount = Math.max(0, originalPrice - discountAmount);
            }

            const pr = stripe.paymentRequest({
                country: 'US',
                currency: price.currency.toLowerCase(),
                total: {
                    label: 'Subscription',
                    amount: Math.round(finalAmount), // Use discounted amount for Google Pay
                },
                requestPayerName: true,
                requestPayerEmail: true,
            });

            // Check if Payment Request is available (Google Pay, Apple Pay, etc.)
            pr.canMakePayment().then(result => {
                console.log("result 2 ", result )
                if (result) {
                    setPaymentRequest(pr);
                }
            });


            // Handle payment method creation for Google Pay/Apple Pay
            pr.on('paymentmethod', async (ev) => {
                console.log("Payment method ", ev)
                setLoading(true);
                try {
                    const paymentMethodId = ev.paymentMethod.id;
                    const customerEmail = ev.paymentMethod.billing_details.email || email;

                    let data = null;

                    if(isSingle){
                        data = await quizService.createSingleSub(customerEmail, priceId, paymentMethodId, name, couponId, productId, secondPrice?.id);
                    }else {
                        data = await quizService.createSub(customerEmail, priceId, paymentMethodId, name, couponId, productId);
                    }

                    if (data?.createdSub?.jwt) {
                        localStorage.setItem('jwt_token', data.createdSub.jwt);
                    }

                    if (data.clientSecret) {
                        const confirm = await stripe.confirmCardPayment(data.clientSecret);
                        if (confirm.error) {
                            ev.complete('fail');
                            setError(confirm.error.message || 'Payment failed');
                            // alert('To failed 1' +  JSON.stringify(confirm))
                            navigate('/subscription/failed', {
                                state: {
                                    error: confirm.error.message || 'Payment failed',
                                    email: customerEmail,
                                    planName: price.nickname || 'AI Learning Plan',
                                    priceId: priceId,
                                    productId: productId
                                }
                            });
                        } else {
                            handleSubSuccessData();
                            pushInfoToGoogleData({
                                event: 'subscription_purchase',
                                data: {
                                    priceId: priceId,
                                    productId: productId,
                                    amount: 0,
                                    currency: price.currency
                                }
                            })
                            ev.complete('success');
                            navigate('/subscription/success', {
                                state: {
                                    email: customerEmail,
                                    planName: price.nickname || 'AI Learning Plan',
                                    amount: `$${(finalAmount / 100).toFixed(2)}` // Use discounted amount in success message
                                }
                            });
                        }
                    } else if (data.subscriptionId || data?.createdSub?.subscriptionId) {
                        // Subscription created successfully without requiring payment confirmation
                        ev.complete('success');
                        handleSubSuccessData();
                        navigate('/subscription/success', {
                            state: {
                                email: customerEmail,
                                planName: price.nickname || 'AI Learning Plan',
                                amount: `$${(finalAmount / 100).toFixed(2)}` // Use discounted amount in success message
                            }
                        });
                    } else {
                        ev.complete('fail');
                        setError('Subscription not created');
                        // alert('To failed 2' +  JSON.stringify(data))
                        navigate('/subscription/failed', {
                            state: {
                                error: 'Subscription not created',
                                email: customerEmail,
                                planName: price.nickname || 'AI Learning Plan',
                                priceId: priceId,
                                productId: productId
                            }
                        });
                    }
                } catch (err) {
                    ev.complete('fail');
                    setError('Payment processing failed');
                    // alert('To failed 3' +  JSON.stringify(err))

                    navigate('/subscription/failed', {
                        state: {
                            error: 'Payment processing failed',
                            email: email,
                            planName: price.nickname || 'AI Learning Plan',
                            priceId: priceId,
                            productId: productId
                        }
                    });
                }
                setLoading(false);
            });
        }
    }, [stripe, price, coupon, email, name, priceId, navigate, location.state?.productId]);

    const sha256Hex = async (text: string): Promise<string> => {
        const normalized = (text || '').trim().toLowerCase();
        const encoder = new TextEncoder();
        const data = encoder.encode(normalized);
        const hashBuffer = await (window.crypto || ({} as any).crypto).subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return hashHex;
    };

    const handleSubSuccessData = async () => {
        try {
            const emailHash = await sha256Hex(email);
            pushInfoToGoogleData({
                event: 'subscription_purchase',
                data: {
                    cardTitle: 'Purchase',
                    currency: price.currency,
                    priceId: price.id,
                    productId: price.product,
                    amount: price.unit_amount,
                    percent_off: coupon?.percent_off || 0,
                    email_sha256: emailHash,
                }
            })
        } catch (e) {
            // Fallback: push without email if hashing fails
            pushInfoToGoogleData({
                event: 'subscription_purchase',
                data: {
                    cardTitle: 'Purchase',
                    currency: price.currency,
                    priceId: price.id,
                    productId: price.product,
                    amount: price.unit_amount,
                    percent_off: coupon?.percent_off || 0,
                }
            })
        }
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!stripe || !elements) return;
        setLoading(true);

        if (!cardNComplete) {
          setError('Please complete the card information');
            setLoading(false);
            setTimeout(() => {
                const cardElement = elements.getElement(CardNumberElement);
                if (cardElement) {
                    cardElement.focus();
                }
            }, 100);
            return;
        }

        if(!cardExComplete){
            setError('Please complete the card information');
            setLoading(false);
            setTimeout(() => {
                const cardElement = elements.getElement(CardExpiryElement);
                if (cardElement) {
                    cardElement.focus();
                }
            }, 100);
            return;
        }

        if (!cardCvComplete) {
            setError('Please complete the card information');
            setLoading(false);
            setTimeout(() => {
                const cardElement = elements.getElement(CardCvcElement);
                if (cardElement) {
                    cardElement.focus();
                }
            }, 100);
            return;
        }

        const cardElement = elements.getElement(CardNumberElement);
        if (!cardElement) return;

        const { paymentMethod, error: pmError } = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
            billing_details: { email, name },
        });
        const funnelStepsData = getFunnel(funnelId || '');
        const newsLetterStatus = getStatus();

        if (pmError) {
            setError(pmError.message || 'Error creating payment method');
            setLoading(false);
            // alert('To failed 4' +  JSON.stringify(pmError))

            navigate('/subscription/failed', {
                state: {
                    error: pmError.message || 'Error creating payment method',
                    email: email,
                    planName: price.nickname || 'AI Learning Plan',
                    priceId: priceId,
                    productId: location.state?.productId
                }
            });
            return;
        }

        const { id } = paymentMethod;
        try {
            let data = null;
            if(isSingle){
                data = await quizService.createSingleSub(email, priceId, id, name, coupon?.id, location.state?.productId, secondPrice?.id);
            }else {
                data = await quizService.createSub(email, priceId, id, name, coupon?.id, location.state?.productId);
            }
            if (data?.createdSub?.jwt) {
                localStorage.setItem('jwt_token', data.createdSub.jwt);
            }

            if (data.clientSecret) {
                const confirm = await stripe.confirmCardPayment(data.clientSecret);
                if (confirm.error) {
                    setError(confirm.error.message || 'Payment failed');
                    await saveUserData({
                        email: email,
                        name: name,
                        funnelSteps: funnelStepsData,
                        selectedPrice: priceId,
                        paymentMethod: id,
                        subscriptionStatus: false,
                        newsLetterStatus: newsLetterStatus
                    });
                    // alert('To failed 5' +  JSON.stringify(confirm))

                    navigate('/subscription/failed', {
                        state: {
                            error: confirm.error.message || 'Payment failed',
                            email: email,
                            planName: price.nickname || 'AI Learning Plan',
                            priceId: priceId,
                            productId: location.state?.productId
                        }
                    });
                } else {
                    await saveUserData({
                        email: email,
                        name: name,
                        funnelSteps: funnelStepsData,
                        selectedPrice: priceId,
                        paymentMethod: id,
                        subscriptionStatus: true,
                        newsLetterStatus: newsLetterStatus
                    });
                    handleSubSuccessData()
                    // Clean up localStorage checkout data on successful payment
                    // console.log('purchase event ', ev)
                    navigate('/subscription/success', {
                        state: {
                            email: email,
                            planName: price.nickname || 'AI Learning Plan',
                            amount: `$${(price.unit_amount / 100).toFixed(2)}`
                        }
                    });
                }
            } else if (data.createdSub && data.createdSub.subscriptionId) {
                await saveUserData({
                    email: email,
                    name: name,
                    funnelSteps: funnelStepsData,
                    selectedPrice: priceId,
                    paymentMethod: id,
                    subscriptionStatus: true,
                    newsLetterStatus: newsLetterStatus
                });
                handleSubSuccessData()
                // Clean up localStorage checkout data on successful subscription creation
                navigate('/subscription/success', {
                    state: {
                        email: email,
                        planName: price.nickname || 'AI Learning Plan',
                        amount: `$${(price.unit_amount / 100).toFixed(2)}`
                    }
                });
            } else {
                setError('Subscription not created');
                await saveUserData({
                    email: email,
                    name: name,
                    funnelSteps: funnelStepsData,
                    selectedPrice: priceId,
                    paymentMethod: id,
                    subscriptionStatus: false,
                    newsLetterStatus: newsLetterStatus
                });
                // alert('To failed 6' +  JSON.stringify(id))

                navigate('/subscription/failed', {
                    state: {
                        error: 'Subscription not created',
                        email: email,
                        planName: price.nickname || 'AI Learning Plan',
                        priceId: priceId,
                        productId: location.state?.productId
                    }
                });
            }
        } catch (err) {
            setError('Payment processing failed');
            await saveUserData({
                email: email,
                name: name,
                funnelSteps: funnelStepsData,
                selectedPrice: priceId,
                paymentMethod: id,
                subscriptionStatus: false,
                newsLetterStatus: newsLetterStatus
            });
            // alert('To failed 7' +  JSON.stringify(err))

            navigate('/subscription/failed', {
                state: {
                    error: 'Payment processing failed',
                    email: email,
                    planName: price.nickname || 'AI Learning Plan',
                    priceId: priceId,
                    productId: location.state?.productId
                }
            });
        }

        setLoading(false);
    };

    const saveUserData = async ({email,
                                    name,
                                    funnelSteps,
                                    selectedPrice,
                                    subscriptionStatus,
                                    paymentMethod,
                                    newsLetterStatus
                                }: { email: string, name: string, paymentMethod: any, funnelSteps: any, selectedPrice: any, subscriptionStatus: boolean, newsLetterStatus: boolean}) => {
        // Save to funnel store
        saveCheckoutData({
            email: email,
            name: name,
            selectedPrice: selectedPrice,
            paymentMethod: paymentMethod,
            subscriptionStatus: subscriptionStatus
        });

        // Get all funnel data for API call
        const allFunnelData = getAllFunnelData();

        // Save to API
        const funnelData = {
            email: email,
            username: name,
            funnelSteps: allFunnelData.funnelSteps,
            selectedPlan: selectedPrice,
            paymentMethod: paymentMethod,
            subscriptionStatus: subscriptionStatus,
            newsLetterStatus: allFunnelData.newsLetterStatus,
            checkoutData: allFunnelData.checkoutData,
            timestamp: allFunnelData.timestamp
        }

        try {
            await quizService.saveFunnelData(funnelData);
        } catch (error) {
            console.error("Failed to save subscription data:", error);
        }
    }

    return (
        <form onSubmit={handleSubmit} className="checkout-form">

            <div className="checkout-section-label">{t('checkout.selectPaymentMethod')}</div>

            <div className="checkout-payments-row">
                {/*<button*/}
                {/*    type="button"*/}
                {/*    className={`payment-method-btn${selectedMethod === 'card' ? ' selected' : ''}`}*/}
                {/*    onClick={() => setSelectedMethod('card')}*/}
                {/*>*/}
                {/*    <img src="/images/methods/credit-card.png" alt="Credit Card" className="pay-icon" />*/}
                {/*</button>*/}
                {paymentRequest && (
                    <div className="payment-request-section">
                        <PaymentRequestButtonElement
                            options={{ paymentRequest }}
                            className="payment-request-button"
                        />
                    </div>
                )}
            </div>
            {clientSecret && email &&
                <div style={{margin: 'auto', width:'100%', paddingBottom: 14 }}>
                    <PayPalElement
                        email={email}
                        name={name}
                        planName={price.nickname}
                        priceId={priceId}
                        secondPrice={secondPrice.id}
                        intentSecret={clientSecret} />
                </div>}
            <div className="checkout-divider"  style={{ width: '110%', marginLeft: -16 }}/>
            {selectedMethod === 'card' && (
                <>
                    <div className="checkout-card-label-row">
                        <span className="checkout-card-label">{t('checkout.creditCard')}</span>
                        <span className="checkout-card-icons">
              <img src="/images/payments/Visa.png" alt="Visa"
                   className={`card-icon${selectedBrand === 'visa' ? ' selected' : ''}`}
                   onClick={() => onBrandClick('visa')}
              />
              <img src="/images/payments/Mastercard.png" alt="Mastercard"
                   className={`card-icon${selectedBrand === 'mastercard' ? ' selected' : ''}`}
                   onClick={() => onBrandClick('mastercard')}
              />
              <img src="/images/payments/Amex.png" alt="Amex"
                   className={`card-icon${selectedBrand === 'amex' ? ' selected' : ''}`}
                   onClick={() => onBrandClick('amex')}
              />
            </span>
                    </div>
                    <div className="checkout-card-fields">
                        {/*<div className={`checkout-card-number${shake ? ' shake' : ''}`}>*/}
                            <CardNumberElement
                                onChange={handleCardChange}
                                className={`checkout-card-number-element${shake ? ' shake' : ''}`}
                                options={{
                                    iconStyle: 'solid',
                                    style: { base: { fontSize: '16px' } }
                            }} />
                        <div className={'cv-block'}>
                            <CardExpiryElement
                                onChange={handleExpChange}
                                className="checkout-expiration-element"
                            />
                            <CardCvcElement
                                onChange={handleCvChange}
                                className="checkout-cv-element"
                            />
                        </div>

                            {/*<CardElement onChange={handleCardChange}*/}
                            {/*             className="checkout-card-element"*/}
                            {/*             options={{*/}
                            {/*                 iconStyle: 'solid',*/}
                            {/*                 style: { base: { fontSize: '16px' } } }} />*/}
                        {/*</div>*/}
                    </div>
                </>
            )}

            {error && <div className="checkout-error">{error}</div>}

            <button type="submit" disabled={loading} className="checkout-btn">
                {loading ? t('checkout.processing') : t('checkout.getInstantAccess')}
            </button>
            <div className="checkout-info-row">
                <span className="checkout-info-item">
                    <img src={'/images/ui-svg/locker.svg'} alt="Lock" width={18} height={18}/>
                    {t('checkout.securePayments')}
                </span>
                <span className="checkout-info-item">
                    <img src={'/images/ui-svg/check-icon-waved.svg'} alt="Cancel" width={18} height={18}/>
                    {t('checkout.cancelAnytime')}</span>
            </div>
        </form>

    );
};


export default CheckoutForm;
